import React from 'react'

const Label = ({ children, htmlFor = null}) => {
  return <label htmlFor={htmlFor}>{children}</label>;
};

export default Label